/**
 * The A2A capability card — authored in a persona's targets.foundry.a2a-card
 * block, projected into Foundry agent metadata as the `a2aCard` JSON string
 * (mirrors metadata.brain), and returned by the bridge's discover_workers.
 *
 * Foundry agent metadata values are capped at 512 chars, so the serialized
 * card must fit one value. Maps onto the A2A AgentCard for the future
 * graduation: summary→description, whenToDelegate→skill description/tags,
 * accepts/returns→skill I/O modes, role→skill name.
 */
export interface A2aCard {
  role: string;
  summary: string;
  whenToDelegate: string;
  accepts: string;
  returns: string;
}

/** Foundry agent metadata value max length (REST API project/agents). */
export const A2A_CARD_MAX_CHARS = 512;

export function serializeA2aCard(card: A2aCard): string {
  return JSON.stringify(card);
}

/** Defensive parse (mirrors parseBrainLink): null on missing/malformed; never throws. */
export function parseA2aCard(raw: string | undefined): A2aCard | null {
  if (!raw) return null;
  let o: unknown;
  try {
    o = JSON.parse(raw);
  } catch {
    return null;
  }
  if (typeof o !== "object" || o === null) return null;
  const c = o as Partial<A2aCard>;
  return {
    role: typeof c.role === "string" ? c.role : "",
    summary: typeof c.summary === "string" ? c.summary : "",
    whenToDelegate: typeof c.whenToDelegate === "string" ? c.whenToDelegate : "",
    accepts: typeof c.accepts === "string" ? c.accepts : "",
    returns: typeof c.returns === "string" ? c.returns : "",
  };
}
